// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"358":"da92e6b1","606":"f0ce8674"}[chunkId] + ".js";
};